module.exports = __webpack_public_path__ + "static/image/help_center_audit_related.svg?60f6bbcb3acd34be2732f0e9493729d9";